import * as $ from "jquery";

import {$body} from 'Core/Body';
import {formatCurrency} from 'Core/Currencies';
import {Notifications} from 'Core/Notifications';
import {ValidationModule} from 'Components/Validation/Validation';
import {CartService, CartServiceResponse} from 'Components/Cart/CartService';
import {CartCommon} from 'Components/Cart/CartCommon';
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import {Step2Component} from 'Components/Cart/Step2/Step2';
import {CartShowMoreBtn} from 'Components/Cart/CartShowMoreBtn';
import {GuestModal} from 'Components/Cart/GuestModal';
import {Decimal} from 'decimal.js';

export const CartOfferModule = (() => {
    const {FORM, OFFER, SUMMARY_PANEL} = Step1Selectors;
    const Selector = {
        CART_ICON: {
            COUNT: ".js_offer_count",
            VALUE: "#offerValue",
            ICON: ".js_nav-icon-calc",
        },

        PRODUCT_TILE: {
            ADD_ITEM: ".js_product_tile_add_to_offer",
        },

        PRODUCT_PAGE: {
            ADD_ITEM: ".js_product_page_add_to_offer",
            OFFER_QUANTITY: ".js_product_offer_quantity ",
            QUANTITY: ".js_product_offer_quantity",
            INCREASER: ".js_product_offer_quantity--increaser",
            DECREASER: ".js_product_offer_quantity--decreaser",
        },

        CATEGORY_PAGE: {
            ADD_ITEM: '.js_category_page_add_to_offer'
        },

        COMMON: {
            REMOVE_ITEM: ".js_remove_from_cart",
        },

        CART: {
            EMPTY_INFO: "#cart_empty",
            DELIVERY_TIME: '#DeliveryTime',

            STEP_2: {
                ATTACHMENT: '#cart_offer_attachment',
                CLEAR_ATTACHMENT: '.clear-file'
            },

        },

        MODAL: '#cart-modal',

    };
    const OFFER_COUNT_LIMIT: number = 50;

    const Message = {
        MAX_OFFER_PRODUCT_LIMIT: "Wybrano największą możliwą ilość produktu",
        OFFER_COUNT_LIMIT: "W kalkulacji możesz mieć maksymalnie " + OFFER_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do kalkulacji przekracza limit."
    };

    const url = window.location.toString();
    const lang = url.split('/')[3]; // It returns language shortcuts like 'pl' or 'en'

    function calcTotalQuantities() {
        CartCommon.calcTotalQuantities(OFFER.OFFER_QUANTITY);
    }

    function executeTotalCalculations() {
        calcTotalQuantities();
        //calcTotalPrice();
    }

    function cartChangeHandler(res: CartServiceResponse) {
        if (res.result) {
            $(SUMMARY_PANEL.TOTAL).html(res.value.total.toString());
            if (res.value.count > 0) {
                $(Selector.CART_ICON.COUNT).show().html(res.value.count.toString());
            } else {
                $(Selector.CART_ICON.COUNT).hide().html('0');
                $(Selector.CART.EMPTY_INFO).show(250);
                $(FORM).hide(250);
            }
            $(Selector.CART_ICON.VALUE).html(res.value.total.toString());
            Notifications.add(res.msg, res.type ? res.type : "offer");
        } else {
            //Notifications.add('Cart - error', 'error');
        }
    }

    function updateCalcIcon(active: boolean) {
        const $icon = $(Selector.CART_ICON.ICON);
        const currentSrc = $icon.attr('src') || '';
        if (active && !currentSrc.includes('-filled')) {
            $icon.attr('src', currentSrc.replace('calc.svg', 'calc-filled.svg'));
        } else if (!active && currentSrc.includes('-filled')) {
            $icon.attr('src', currentSrc.replace('calc-filled.svg', 'calc.svg'));
        }
    }

    function extractCommonData() {
        const $this: JQuery<HTMLElement> = $(this);
        const productId: string = $this.data('product-id');

        return {$this, productId}
    }

    function ProdTileAddToCart(this: HTMLElement) {
        const {productId} = extractCommonData.call(this);
        const itGoesBeyondCountLimit: boolean = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT, OFFER_COUNT_LIMIT);

        if (itGoesBeyondCountLimit) {
            Notifications.add(Message.OFFER_COUNT_LIMIT, "warning");
        } else {
            CartService.add(lang, productId, 1).done(cartChangeHandler)
        }
    }

    function RemoveFromCart(this: HTMLElement) {
        const {$this, productId} = extractCommonData.call(this);
        $(this).attr('disabled', 'disabled');
        CartService.remove(lang, productId)
            .done(cartChangeHandler)
            .then(() => updateDeliveryTime())
            .then(() => $this.closest(OFFER.OFFER_CONTAINER).remove())
            .then(() => executeTotalCalculations());
    }

    function ClearAllProductsFromCart() {
        CartService.clear_offer(lang)
            .done(cartChangeHandler)
            .then(() => updateDeliveryTime())
            .then(() => $(Selector.CART.EMPTY_INFO).show(250))
            .then(() => $(FORM).hide(250))
        $(Selector.CART_ICON.COUNT).hide().html('0');
    }

    function IncreaseOfferProdQuantity(this) {
        const {productId} = extractCommonData.call(this);
        const $input = $(this).next('input');
        const row = $(this).closest(OFFER.OFFER_CONTAINER);
        const price = row.data('product-price');
        const $total = row.find(OFFER.OFFER_TOTAL);
        let quantity = new Decimal($input.val() as number);
        let max = new Decimal($input.attr('max'));
        let unit_is_float = CartCommon.getDecimalPlaces($input.data('input-step'));

        if (quantity.greaterThanOrEqualTo(max)) {
            Notifications.add(Message.MAX_OFFER_PRODUCT_LIMIT, "info");
            return false;
        } else {
            const step = $input.data('input-step');
            quantity = quantity.plus(step);
            $input.val(quantity.toFixed(unit_is_float));
            $total.text(formatCurrency(price * quantity.toNumber()));
            $total.attr('data-total-price', price * quantity.toNumber());
            row.find('button').attr('disabled', 'disabled');
            CartService.update(productId, quantity.toNumber())
                .done($result => {
                    $input.val(quantity.toFixed(unit_is_float));
                    $total.text(formatCurrency(price * quantity.toNumber()));
                    $total.attr('data-total-price', price * quantity.toNumber());
                    row.find('button').removeAttr('disabled');
                    $(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                    if ($result.msg != undefined && $result.msg != null) {
                        Notifications.add($result.msg, "warning");
                    }
                })
        }
    }

    function DecreaseOfferProdQuantity(this) {
        const {productId} = extractCommonData.call(this);
        const $input = $(this).prev('input');
        const row = $(this).closest(OFFER.OFFER_CONTAINER);
        const price = row.data('product-price');
        const $total = row.find(OFFER.OFFER_TOTAL);

        let quantity = new Decimal($input.val() as number);
        let min = new Decimal($input.attr('min'));
        let unit_is_float = CartCommon.getDecimalPlaces($input.data('input-step'));

        if (quantity.lessThanOrEqualTo(min)) {
            return false;
        } else {
            const step = $input.data('input-step');
            quantity = quantity.minus(step);
            $input.val(quantity.toString());
            $total.text(formatCurrency(price * quantity.toNumber()));
            $total.attr('data-total-price', price * quantity.toNumber());
            row.find('button').attr('disabled', 'disabled');
            CartService.update(productId, quantity.toNumber())
                .done($result => {
                    $input.val(quantity.toFixed(unit_is_float));
                    $total.text(formatCurrency(price * quantity.toNumber()));
                    $total.attr('data-total-price', price * quantity.toNumber());
                    row.find('button').removeAttr('disabled');
                    $(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                    if ($result.msg != undefined && $result.msg != null) {
                        Notifications.add($result.msg, "warning");
                    }
                })
        }
    }

    function inputKeyupHandler(this, event: JQueryEventObject) {
        CartCommon.inputKeyupHandler(this, event, Message.MAX_OFFER_PRODUCT_LIMIT);
    }

    function changeProductQuantity() {
        CartCommon.changeProductQuantity(this, Selector.PRODUCT_PAGE.OFFER_QUANTITY, Message.MAX_OFFER_PRODUCT_LIMIT)
    }

    function focusoutProductPageProductQuantity() {
        CartCommon.focusoutProductPageProductQuantity(this, Message.MAX_OFFER_PRODUCT_LIMIT);
    }

    function inputFocusoutHandler() {
        CartCommon.inputFocusoutHandler(this);
    }

    function updateDeliveryTime() {
        CartService.getDeliveryTime().done(msg => {
            $(Selector.CART.DELIVERY_TIME).toggle(!!msg).html(msg);
        });
    }

    function onChangeCartOfferAttachment() {
        if ($(this).val() != '') {
            showDeleteAttachmentButton(this, true);
        } else {
            showDeleteAttachmentButton(this, false);
        }
    }

    function showDeleteAttachmentButton(elem, show) {
        if (show) {
            $(elem).parent().children('.input-group-append').show();
        } else {
            $(elem).parent().children('.input-group-append').hide();
        }
    }

    function clearOfferAttachment() {
        let parent = $(this).parent()
        parent.children('input').val('').change();
        parent.children('.invalid-feedback').hide();
    }

    $body.on("click", Selector.PRODUCT_TILE.ADD_ITEM, ProdTileAddToCart);
    $body.on("click", Selector.PRODUCT_PAGE.INCREASER, changeProductQuantity);
    $body.on("click", Selector.PRODUCT_PAGE.DECREASER, changeProductQuantity);
    $body.on("focusout", Selector.PRODUCT_PAGE.QUANTITY, focusoutProductPageProductQuantity);

    // Step1
    $body.on("click", OFFER.OFFER_CLEAR_ALL, ClearAllProductsFromCart);
    $body.on("click", OFFER.OFFER_REMOVE, RemoveFromCart);
    $body.on("keyup", OFFER.OFFER_QUANTITY, inputKeyupHandler);
    $body.on("keyup", OFFER.OFFER_QUANTITY, executeTotalCalculations);
    $body.on("focusout", OFFER.OFFER_QUANTITY, inputFocusoutHandler);
    $body.on("focusout", OFFER.OFFER_QUANTITY, executeTotalCalculations);
    $body.on("click", OFFER.OFFER_QUANTITY_CONTROL_INCREASE, IncreaseOfferProdQuantity);
    $body.on("click", OFFER.OFFER_QUANTITY_CONTROL_DECREASE, DecreaseOfferProdQuantity);
    $body.on('click', OFFER.OFFER_QUANTITY_CONTROL_INCREASE, executeTotalCalculations);
    $body.on('click', OFFER.OFFER_QUANTITY_CONTROL_DECREASE, executeTotalCalculations);
    $body.on('change', Selector.CART.STEP_2.ATTACHMENT, onChangeCartOfferAttachment);
    $body.on('click', Selector.CART.STEP_2.CLEAR_ATTACHMENT, clearOfferAttachment);

    return true;
})();

export {
    ValidationModule,
    Step2Component,
    CartShowMoreBtn,
    GuestModal
}
import * as $ from "jquery";

import {$body} from 'Core/Body';
import {formatCurrency} from 'Core/Currencies';
import {Notifications} from 'Core/Notifications';
import {ValidationModule} from 'Components/Validation/Validation';
import {CartService, CartServiceResponse} from 'Components/Cart/CartService';
import {CartCommon} from 'Components/Cart/CartCommon';
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import {Step2Component} from 'Components/Cart/Step2/Step2';
import {CartShowMoreBtn} from 'Components/Cart/CartShowMoreBtn';
import {GuestModal} from 'Components/Cart/GuestModal';
import {Decimal} from 'decimal.js';

export const CartOfferModule = (() => {
    const {FORM, OFFER, SUMMARY_PANEL} = Step1Selectors;
    const Selector = {
        CART_ICON: {
            COUNT: ".js_offer_count",
            VALUE: "#offerValue",
            ICON: ".js_nav-icon-calc",
        },

        PRODUCT_TILE: {
            ADD_ITEM: ".js_product_tile_add_to_offer",
        },

        PRODUCT_PAGE: {
            ADD_ITEM: ".js_product_page_add_to_offer",
            OFFER_QUANTITY: ".js_product_offer_quantity ",
            QUANTITY: ".js_product_offer_quantity",
            INCREASER: ".js_product_offer_quantity--increaser",
            DECREASER: ".js_product_offer_quantity--decreaser",
        },

        CATEGORY_PAGE: {
            ADD_ITEM: '.js_category_page_add_to_offer'
        },

        COMMON: {
            REMOVE_ITEM: ".js_remove_from_cart",
        },

        CART: {
            EMPTY_INFO: "#cart_empty",
            DELIVERY_TIME: '#DeliveryTime',

            STEP_2: {
                ATTACHMENT: '#cart_offer_attachment',
                CLEAR_ATTACHMENT: '.clear-file'
            },

        },

        MODAL: '#cart-modal',

    };
    const OFFER_COUNT_LIMIT: number = 50;

    const Message = {
        MAX_OFFER_PRODUCT_LIMIT: "Wybrano największą możliwą ilość produktu",
        OFFER_COUNT_LIMIT: "W kalkulacji możesz mieć maksymalnie " + OFFER_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do kalkulacji przekracza limit."
    };

    const url = window.location.toString();
    const lang = url.split('/')[3]; // It returns language shortcuts like 'pl' or 'en'

    function calcTotalQuantities() {
        CartCommon.calcTotalQuantities(OFFER.OFFER_QUANTITY);
    }

    function executeTotalCalculations() {
        calcTotalQuantities();
        //calcTotalPrice();
    }

    function cartChangeHandler(res: CartServiceResponse) {
        if (res.result) {
            $(SUMMARY_PANEL.TOTAL).html(res.value.total.toString());
            if (res.value.count > 0) {
                $(Selector.CART_ICON.COUNT).show().html(res.value.count.toString());
            } else {
                $(Selector.CART_ICON.COUNT).hide().html('0');
                $(Selector.CART.EMPTY_INFO).show(250);
                $(FORM).hide(250);
            }
            $(Selector.CART_ICON.VALUE).html(res.value.total.toString());
            Notifications.add(res.msg, res.type ? res.type : "offer");
        } else {
            //Notifications.add('Cart - error', 'error');
        }
    }

    function updateCalcIcon(active: boolean) {
        const $icon = $(Selector.CART_ICON.ICON);
        const currentSrc = $icon.attr('src') || '';
        if (active && !currentSrc.includes('-filled')) {
            $icon.attr('src', currentSrc.replace('calc.svg', 'calc-filled.svg'));
        } else if (!active && currentSrc.includes('-filled')) {
            $icon.attr('src', currentSrc.replace('calc-filled.svg', 'calc.svg'));
        }
    }

    function extractCommonData() {
        const $this: JQuery<HTMLElement> = $(this);
        const productId: string = $this.data('product-id');

        return {$this, productId}
    }

    function ProdTileAddToCart(this: HTMLElement) {
        const {productId} = extractCommonData.call(this);
        const itGoesBeyondCountLimit: boolean = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT, OFFER_COUNT_LIMIT);

        if (itGoesBeyondCountLimit) {
            Notifications.add(Message.OFFER_COUNT_LIMIT, "warning");
        } else {
            CartService.add(lang, productId, 1).done(cartChangeHandler)
        }
    }

    function RemoveFromCart(this: HTMLElement) {
        const {$this, productId} = extractCommonData.call(this);
        $(this).attr('disabled', 'disabled');
        CartService.remove(lang, productId)
            .done(cartChangeHandler)
            .then(() => updateDeliveryTime())
            .then(() => $this.closest(OFFER.OFFER_CONTAINER).remove())
            .then(() => executeTotalCalculations());
    }

    function ClearAllProductsFromCart() {
        CartService.clear_offer(lang)
            .done(cartChangeHandler)
            .then(() => updateDeliveryTime())
            .then(() => $(Selector.CART.EMPTY_INFO).show(250))
            .then(() => $(FORM).hide(250))
        $(Selector.CART_ICON.COUNT).hide().html('0');
    }

    function IncreaseOfferProdQuantity(this) {
        const {productId} = extractCommonData.call(this);
        const $input = $(this).next('input');
        const row = $(this).closest(OFFER.OFFER_CONTAINER);
        const price = row.data('product-price');
        const $total = row.find(OFFER.OFFER_TOTAL);
        let quantity = new Decimal($input.val() as number);
        let max = new Decimal($input.attr('max'));
        let unit_is_float = CartCommon.getDecimalPlaces($input.data('input-step'));

        if (quantity.greaterThanOrEqualTo(max)) {
            Notifications.add(Message.MAX_OFFER_PRODUCT_LIMIT, "info");
            return false;
        } else {
            const step = $input.data('input-step');
            quantity = quantity.plus(step);
            $input.val(quantity.toFixed(unit_is_float));
            $total.text(formatCurrency(price * quantity.toNumber()));
            $total.attr('data-total-price', price * quantity.toNumber());
            row.find('button').attr('disabled', 'disabled');
            CartService.update(productId, quantity.toNumber())
                .done($result => {
                    $input.val(quantity.toFixed(unit_is_float));
                    $total.text(formatCurrency(price * quantity.toNumber()));
                    $total.attr('data-total-price', price * quantity.toNumber());
                    row.find('button').removeAttr('disabled');
                    $(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                    if ($result.msg != undefined && $result.msg != null) {
                        Notifications.add($result.msg, "warning");
                    }
                })
        }
    }

    function DecreaseOfferProdQuantity(this) {
        const {productId} = extractCommonData.call(this);
        const $input = $(this).prev('input');
        const row = $(this).closest(OFFER.OFFER_CONTAINER);
        const price = row.data('product-price');
        const $total = row.find(OFFER.OFFER_TOTAL);

        let quantity = new Decimal($input.val() as number);
        let min = new Decimal($input.attr('min'));
        let unit_is_float = CartCommon.getDecimalPlaces($input.data('input-step'));

        if (quantity.lessThanOrEqualTo(min)) {
            return false;
        } else {
            const step = $input.data('input-step');
            quantity = quantity.minus(step);
            $input.val(quantity.toString());
            $total.text(formatCurrency(price * quantity.toNumber()));
            $total.attr('data-total-price', price * quantity.toNumber());
            row.find('button').attr('disabled', 'disabled');
            CartService.update(productId, quantity.toNumber())
                .done($result => {
                    $input.val(quantity.toFixed(unit_is_float));
                    $total.text(formatCurrency(price * quantity.toNumber()));
                    $total.attr('data-total-price', price * quantity.toNumber());
                    row.find('button').removeAttr('disabled');
                    $(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                    if ($result.msg != undefined && $result.msg != null) {
                        Notifications.add($result.msg, "warning");
                    }
                })
        }
    }

    function inputKeyupHandler(this, event: JQueryEventObject) {
        CartCommon.inputKeyupHandler(this, event, Message.MAX_OFFER_PRODUCT_LIMIT);
    }

    function changeProductQuantity() {
        CartCommon.changeProductQuantity(this, Selector.PRODUCT_PAGE.OFFER_QUANTITY, Message.MAX_OFFER_PRODUCT_LIMIT)
    }

    function focusoutProductPageProductQuantity() {
        CartCommon.focusoutProductPageProductQuantity(this, Message.MAX_OFFER_PRODUCT_LIMIT);
    }

    function inputFocusoutHandler() {
        CartCommon.inputFocusoutHandler(this);
    }

    function updateDeliveryTime() {
        CartService.getDeliveryTime().done(msg => {
            $(Selector.CART.DELIVERY_TIME).toggle(!!msg).html(msg);
        });
    }

    function onChangeCartOfferAttachment() {
        if ($(this).val() != '') {
            showDeleteAttachmentButton(this, true);
        } else {
            showDeleteAttachmentButton(this, false);
        }
    }

    function showDeleteAttachmentButton(elem, show) {
        if (show) {
            $(elem).parent().children('.input-group-append').show();
        } else {
            $(elem).parent().children('.input-group-append').hide();
        }
    }

    function clearOfferAttachment() {
        let parent = $(this).parent()
        parent.children('input').val('').change();
        parent.children('.invalid-feedback').hide();
    }

    $body.on("click", Selector.PRODUCT_TILE.ADD_ITEM, ProdTileAddToCart);
    $body.on("click", Selector.PRODUCT_PAGE.INCREASER, changeProductQuantity);
    $body.on("click", Selector.PRODUCT_PAGE.DECREASER, changeProductQuantity);
    $body.on("focusout", Selector.PRODUCT_PAGE.QUANTITY, focusoutProductPageProductQuantity);

    // Step1
    $body.on("click", OFFER.OFFER_CLEAR_ALL, ClearAllProductsFromCart);
    $body.on("click", OFFER.OFFER_REMOVE, RemoveFromCart);
    $body.on("keyup", OFFER.OFFER_QUANTITY, inputKeyupHandler);
    $body.on("keyup", OFFER.OFFER_QUANTITY, executeTotalCalculations);
    $body.on("focusout", OFFER.OFFER_QUANTITY, inputFocusoutHandler);
    $body.on("focusout", OFFER.OFFER_QUANTITY, executeTotalCalculations);
    $body.on("click", OFFER.OFFER_QUANTITY_CONTROL_INCREASE, IncreaseOfferProdQuantity);
    $body.on("click", OFFER.OFFER_QUANTITY_CONTROL_DECREASE, DecreaseOfferProdQuantity);
    $body.on('click', OFFER.OFFER_QUANTITY_CONTROL_INCREASE, executeTotalCalculations);
    $body.on('click', OFFER.OFFER_QUANTITY_CONTROL_DECREASE, executeTotalCalculations);
    $body.on('change', Selector.CART.STEP_2.ATTACHMENT, onChangeCartOfferAttachment);
    $body.on('click', Selector.CART.STEP_2.CLEAR_ATTACHMENT, clearOfferAttachment);

    return true;
})();

export {
    ValidationModule,
    Step2Component,
    CartShowMoreBtn,
    GuestModal
}
